import Keycloak, { KeycloakInitOptions } from "keycloak-js";

export const keycloak = Keycloak("/keycloak.json");
export const keycloakInitOptions: KeycloakInitOptions = {
    onLoad: "login-required",
};
